<div
    class="dropzone w-100"
    tabindex="0"
    [ngClass]="status()"
    [class.dragging]="isDragging()"
    (click)="onHostClick()"
    (keypress)="onHostClick()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
>
    <div
        class="d-flex flex-column w-100 h-100 justify-content-center align-items-center"
    >
        <i class="fa-light mb-4" [ngClass]="icon()"></i>
        <p class="font-xl weight-medium m-0">{{ heading() }}</p>
        <p class="font-sm m-0">{{ subHeading() }}</p>
    </div>

    <input
        #fileInput
        type="file"
        multiple
        class="file-input"
        (change)="onInputChange($event)"
    />
</div>
